import styled from "styled-components";
import React, { useEffect } from "react";
import { useState } from "react";

import { IonIcon } from "@ionic/react";
import {
  barChartOutline,
  barChart,
  documentTextOutline,
  documentText,
  chatbubbles,
  chatbubblesOutline,
  informationCircle,
  informationCircleOutline,
  flashOutline,
  flash,
  cogOutline,
  cog,
} from "ionicons/icons";
import { useNavigate, useLocation } from "react-router-dom";

const MobileNavWrapper = styled.div`
  position: fixed;
  bottom: 0;
  height: 85px;
  padding: 10px 0 10px 0;
  width: 100%;
  z-index: 10;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  background-color: #ffffffdf;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  -webkit-box-shadow: 0px -2px 16px -6px #000000;
  box-shadow: 0px -2px 16px -6px #000000;

  @media (min-width: 800px) {
    display: none;
  }
`;

const MobileNavOption = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: color 0.2s ease-in-out;
  -webkit-tap-highlight-color: white;
  -webkit-focus-ring-color: white;
  height: calc(24px+4px+11px);
  cursor: pointer;

  ion-icon {
    height: 24px;
    width: 24px;
    transition: color 0.2s ease-in-out;
  }
  p {
    margin-top: 4px;
    font-size: 11px;
    transition: color 0.2s ease-in-out;
    user-select: none;
  }
`;

function MobileNav(props: MobileNavProps) {
  const [pageName, setPageName] = useState<string>("dashboard");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/");
    const pageName = path[path.length - 1];
    setPageName(pageName);
  }, [location]);

  return (
    <MobileNavWrapper>
      <MobileNavOption onClick={() => navigate("/overview")}>
        <IonIcon
          icon={pageName.includes("overview") ? barChart : barChartOutline}
          size="large"
          style={{
            color: pageName.includes("overview")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: pageName.includes("overview")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Overview
        </p>
      </MobileNavOption>
      <MobileNavOption onClick={() => navigate("/reports")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("reports")
              ? documentText
              : documentTextOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("reports")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("reports")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          My Reports
        </p>
      </MobileNavOption>
      <MobileNavOption onClick={() => navigate("/stories")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("stories")
              ? chatbubbles
              : chatbubblesOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("stories")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("stories")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Stories
        </p>
      </MobileNavOption>
    {/*   <MobileNavOption onClick={() => navigate("/cheatsheets")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("cheatsheets")
              ? flash
              : flashOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("cheatsheets")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("cheatsheets")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Cheat Sheets
        </p>
      </MobileNavOption> */}
      <MobileNavOption onClick={() => navigate("help")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("help")
              ? informationCircle
              : informationCircleOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("help")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("help")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Help
        </p>
      </MobileNavOption>
    </MobileNavWrapper>
  );
}

export default React.memo(MobileNav);

interface MobileNavProps {}
